class CreateClub {
    constructor($scope, $state, $stateParams, $mdMedia, $mdDialog, $rootScope,
        authService, localStorageService, CONSTANTS, uploadService, $interval, $timeout) {
        'ngInject';
        $rootScope.title = "Create Club"

        //For viewing searchbox
        $scope.showSearchBottomSheet = true;

        $scope.clubActionBtns = true; //For removing the action button (Add,Create and Update) in footer

        //localStorageService details for student
        $scope.showSessionName = [];

        //Members added to club stored
        $scope.addedMemberData = [];

        //Roles of members added
        $scope.allRoles = [];

        //To get detals of members
        $scope.userMgt = [];

        //Selected users for adding to club
        $scope.selectedUsers = [];

        //To get academic details
        $scope.allSessions = {};
        $scope.allCurriculum = {};
        $scope.allBatchess = {};
        $scope.allClassess = {};
        $scope.club = {};
        $scope.clubs = true;

        //If updating details of a club ,fetch clubId
        $scope.stateId = 'club'

        //To check member exist to create and update aclub
        $scope.ifMembersExist = false;

        //To set authority of viewing create club button-after adding valid users
        $scope.showCreateButton = false;
        $scope.showSearchBox = false;
        $scope.ifCliked = false;
        $scope.ifUpdated = false;
        $scope.ifRemoved = false;

        //To identify role Id of participants of club.
        $scope.whoIsThis = '';

        //To set privilege and roletypes
        let moduleDetails = [];
        let addedSessionsID = [];
        //To fetch person collection
        let personArrys = [];

        //To get participant role id from privileges
        let roles = [];
        let uid = localStorageService.get('user_id')

        let schoolId = localStorageService.get('school_id');


        $scope.clearParentFields = function () {

        }
        $scope.currentDate = new Date();
        // Meteor.call("timeZone", function(error, result) {
        //     if (error) {
        //         if (error.error) {
        //             toastr.error("Server Interpreted.Please try after some time.")
        //         }
        //     } else {
        //         $scope.currentDate = new Date();
        //         $scope.$apply();
        //     }
        // })
        console.log($stateParams)
        if ($stateParams.club_id) {
            localStorageService.set('selectedClubId', $stateParams.club_id)
        }

        $scope.initialLoad = () => {
            $scope.club_id = $stateParams.club_id;
            $scope.userNames = [];
            $scope.club = {};
            let send = {
                myUserId: localStorageService.get('user_id'),
                school_id: localStorageService.get('school_id')
            }
            authService.callAPI("/v0/club/create/init", "POST",
                { args: send }, function (resp) {
                    try {
                        if (!resp.error) {
                            setData(resp.result.data.details)
                        }

                    } catch (e) {
                        console.log(e)
                    }

                })
        }
        var item = {};
        var name, club_owner;
        $scope.showCheckBox = true;
        $scope.showSelect = true;
        $scope.showBrowseBtn = true;
        $scope.showRoleArea = true;
        $scope.initialLoad()
        function setData(firstResponse) {
            moduleDetails = firstResponse.moduleDetails
            $scope.moduleDetailsData = firstResponse.moduleDetails
            let sett = firstResponse.sett
            $scope.allSessions = _.find(sett, function (one) {
                return one.type == 'session'
            })
            $scope.allCurriculum = _.find(sett, function (one) {
                return one.type == 'curriculum'
            })
            $scope.allClassess = _.find(sett, function (one) {
                return one.type == 'class'
            })
            $scope.allBatchess = _.find(sett, function (one) {
                return one.type == 'batch'
            })
            if ($stateParams.club_id) {
                if ($stateParams.mode == 'remove') {
                    $scope.selectedActivity = {
                        "name": 'Remove Users'
                    };
                    $scope.clubMode = $stateParams.mode;
                    $scope.showCheckBox = true;
                    $scope.showBrowseBtn = false;
                    $scope.showSelect = true;
                    $scope.showSeachFiled = true;
                    $scope.showRoleArea = false;
                }
                if ($stateParams.mode == 'addmore') {
                    $scope.selectedActivity = {
                        "name": 'Add New Users'
                    };
                    $scope.clubMode = $stateParams.mode;
                    $scope.showCheckBox = false;
                    $scope.showBrowseBtn = false;
                    $scope.showSelect = false;
                    $scope.showSeachFiled = true;
                }
                if ($stateParams.mode == 'view') {
                    $scope.showRoleArea = false;
                    $scope.showSeachFiled = true;
                    $scope.selectedActivity = {
                        "name": 'View Club Users'
                    };
                    $scope.clubMode = $stateParams.mode;
                    $scope.showCheckBox = false;
                    $scope.showBrowseBtn = false;
                }
                $scope.clubDataExits()
            } else {
                $scope.isCreateClub = true;
            }
        }
        // this.subscribe('getSession');
        // this.subscribe('getModulesFeatures', () => [localStorageService.get('school_id')]);

        $scope.clubDataExits = () => {
            let send = {
                myUserId: localStorageService.get('user_id'),
                schoolId: localStorageService.get('school_id'),
                club_id : $stateParams.club_id
            }
            authService.callAPI("/v0/club/create/clubListToUpdate", "POST",
            {args:send}, function (resp) {
                    try {
                        if (!resp.error) {
                            setDataForView(resp.result.data.details)
                        }

                    } catch (e) {
                        console.log(e)
                    }

                })
        }

        function setDataForView(response) {
            console.log(response)
            $scope.userNames = [];
            let itemcount = 0;
            let getClubData = response.clubs
            let userDocs = response.userDocs
            $scope.getClubData = {};
            $scope.getClubData = getClubData[0];
            $scope.club.name = $scope.getClubData.name
            $scope.club.logo = CONSTANTS.FILE_UPLOAD_URL + $scope.getClubData.logo
            $scope.totalUsersInThsClub = $scope.getClubData.users.length
            $scope.array = []
            _.each($scope.getClubData.users, function (eachClubUser) {
                if (eachClubUser) {
                    let personArrys = [];
                    personArrys = _.filter(userDocs, function (one) {
                        return one.user_id == eachClubUser.user_id
                    })
                    if (personArrys && personArrys.length) {
                        let name = personArrys[0].userDoc[0];
                        if (name) {
                            let userPic = undefined
                            $scope.showSearchBox = true;
                            if (name.image) {
                                userPic = CONSTANTS.FILE_UPLOAD_URL + name.image.original;
                            } else {
                                userPic = CONSTANTS.FILE_UPLOAD_URL + '/uploads/header/profile_61x64.png';
                            }
                            if (personArrys[0] && personArrys[0].role_ids) {
                                club_owner = eachClubUser.user_id === eachClubUser.added_by ? true : false;
                                let added = false;
                                _.each(personArrys[0].role_ids, function (roleId) {
                                    let roleMode = $scope.identifyUserRoleId(roleId);
                                    if (roleMode.indexOf("Student") != -1 && $scope.allSessions && $scope.allCurriculum && $scope.allClassess && $scope.allBatchess) {
                                        console.log('roleMode')
                                        sessionname = _.find($scope.allSessions.list, function (data) {
                                            return data._id === personArrys[0].session_id;
                                        })
                                        curriculumname = _.find($scope.allCurriculum.list, function (data) {
                                            return data._id === personArrys[0].curriculum_id;
                                        })
                                        classname = _.find($scope.allClassess.list, function (data) {
                                            return data._id === personArrys[0].class_id;
                                        })
                                        batchname = _.find($scope.allBatchess.list, function (data) {
                                            return data._id === personArrys[0].batch_id;
                                        })
                                        var userDetails = {
                                            user_id: name._id,
                                            name: name.name,
                                            sess_id: sessionname._id,
                                            sess_name: sessionname.name,
                                            cur_id: curriculumname._id,
                                            cur_name: curriculumname.name,
                                            cls_id: classname._id,
                                            cls_name: classname.name,
                                            btc_id: batchname._id,
                                            btc_name: batchname.name,
                                            role_type: "student",
                                            owner: club_owner,
                                            can_delete: eachClubUser.can_delete,
                                            image: userPic,
                                            username: name.username,
                                            admission_number: name.admission_number
                                        }
                                        userDetails.hideChkBox = ((userDetails.can_delete == false && userDetails.owner == true) || (userDetails.can_delete == false && userDetails.owner == false)) ? false : true;

                                        $scope.userNames.push(userDetails);
                                        return;
                                    } else if (roleMode.indexOf("Student") == -1) {
                                        let roleMode = $scope.identifyUserRoleId(roleId);
                                        
                                        if (!added) {
                                            var userDetails = {
                                                user_id: name._id,
                                                name: name.name,
                                                role_type: [roleMode],
                                                owner: club_owner,
                                                can_delete: eachClubUser.can_delete,
                                                image: userPic,
                                                username: name.username,
                                                empNo: name.employee_no
                                            }
                                            userDetails.hideChkBox = ((userDetails.can_delete == false && userDetails.owner == true) || (userDetails.can_delete == false && userDetails.owner == false)) ? false : true;
                                            added = true;
                                            $scope.userNames.push(userDetails);
                                            return;
                                        } else {
                                            $scope.userNames[($scope.userNames.length - 1)].role_type.push(roleMode)
                                        }
                                    }

                                })
                                $scope.userNames = _.uniq($scope.userNames);
                                if ($scope.userNames != null) {
                                    $scope.ifMembersExist = true;
                                }
                                
                            }


                            $scope.club_Members = angular.copy($scope.userNames);
                            $scope.selectedUsers = $scope.club_Members
                            console.log($scope.club_Members)
                        }
                    }
                }
            })
            console.log($scope.club)
            $scope.$apply();
        }

        //To show search list
        $scope.showDropBox = () => {
            $scope.showSearchBottomSheet = true
        }

        /*
         * Creates a club after validating the details
         * 
         * @param : null
         * 
         * @return - null
         */
        $scope.createNewClub = function () {
            $scope.loading = true;
            $scope.clubActionBtns = false;
            $scope.ifUpdated = true;
            $scope.selectedUserstoClub = _.uniq($scope.selectedUserstoClub)

            for (var i = 0; i < $scope.selectedUsers.length; i++) {
                var data = $scope.selectedUsers[i];
                $scope.membersObj.push(data);
            }
            $scope.clubMember = [];
            $scope.clubDetails = {};
            let arrayObj = {};
            let newArrayObj = {};
            if ($stateParams.club_id) { //Its for updating the club with new users
                let existingMemberCount = 0;
                _.each($scope.membersObj, function (eachUser) {
                    let isexisting = false;
                    if (eachUser) {
                        _.each($scope.getClubData.users, function (eachmember) {
                            if (eachUser._id === eachmember.user_id) {
                                isexisting = true;
                                existingMemberCount++;
                            }
                        })
                        if (!isexisting) {
                            var users = {
                                user_id: eachUser._id,
                                status: 'active',
                                added_by: uid,
                                can_delete: true,
                                added_date: $scope.currentDate
                            }
                            $scope.clubMember.push(users);
                        }
                    }
                })
                $scope.clubDetails = $scope.clubMember;
                if (existingMemberCount > 0)
                    toastr.error(existingMemberCount + " member(s) is/are already members of the club")
                if ($scope.clubDetails.length == 0) {
                    localStorageService.set('selectedClubId', $stateParams.club_id)
                    localStorageService.set('isClubOwnerID', Meteor.userId())
                    $state.go('clubPost');
                    toastr.error("No new members")
                    return;
                }
            } else { //Its for inserting the club with new users          
                $scope.clubDetails.name = $scope.clubName;
                $scope.clubDetails.created_by = uid;
                $scope.clubDetails.created_date = $scope.currentDate;
                $scope.clubDetails.status = 'active';
                if ($scope.serverFileurl) {
                    $scope.clubDetails.logo = $scope.serverFileurl;
                }
                $scope.clubDetails.school_id = schoolId;

                _.each($scope.membersObj, function (eachUser) {
                    if (eachUser) {
                        var users = {
                            user_id: eachUser._id,
                            status: 'active',
                            added_by: uid,
                            can_delete: true,
                            added_date: $scope.currentDate
                        }
                        $scope.clubMember.push(users);

                    }
                })

                if ($scope.isCreateClub == true) {
                    var usersData = {
                        user_id: uid,
                        status: 'active',
                        added_by: uid,
                        can_delete: false,
                        added_date: $scope.currentDate
                    }
                    let id = Math.random().toString(36).substr(2, 10)
                    // var mongoose = require('mongoose');
                    //let id = new mongoose.Types.ObjectId().toString()
                    newArrayObj._id = id;
                    newArrayObj.item = "Created  " + $scope.club.name;
                    newArrayObj.status = "approved";
                    newArrayObj.approver_id = uid;
                    newArrayObj.doc_type = "auto_generated";
                    newArrayObj.club_name = $scope.club.name;
                    newArrayObj.date = $scope.currentDate;
                    newArrayObj.school_id = schoolId;
                }
                $scope.clubMember.push(usersData);
                // _.each($scope.myHODData, function(eachHod) {
                //   $scope.clubMember.push(eachHod);
                // })

                // _.each($scope.myHOSData, function(eachHos) {
                //   $scope.clubMember.push(eachHos);
                // })
                // _.each($scope.myPrinceData, function(eachprincipal) {
                //   $scope.clubMember.push(eachprincipal);
                // })
                $scope.clubDetails.users = [];
                $scope.clubMember = _.uniq($scope.clubMember);
                _.each($scope.clubMember, function (eachMember) {
                    if (eachMember != null) {
                        $scope.clubDetails.users.push(eachMember)
                    }

                })
            }
            $scope.determinateValue = true;
            $scope.clubDetails.academic_year = localStorageService.get('academic_year')
            authService.callAPI("/v0/club/create", "POST",
                {
                    userId: localStorageService.get('user_id'),
                    club_id: $stateParams.club_id,
                    details: angular.copy($scope.clubDetails)
                }, function (resp) {
                    try {
                        console.log(resp)
                        
                        if (!resp.error) {
                            let result = resp.result.data.data
                            $scope.determinateValue = 1;
                            $interval(function () {
                                $scope.determinateValue += 1;
                            }, 400)
                            $timeout(function () {
                                $scope.determinateValue = false;
                                if ($stateParams.mode == 'addmore') {
                                    toastr.success("New member(s) added successfully!");
                                } else {
                                    toastr.success("Club created successfully!");
                                }


                                localStorageService.set('selectedClubId', result);
                                localStorageService.set('isClubOwnerID', localStorageService.get('user_id'))
                                $state.go('clubPost');
                                $scope.addedMemberData = [];
                                $scope.loading = false;
                            }, 5000)
                        } else {
                            toastr.error("Some thing went wrong !.Please try after some time.dd")
                            $scope.ifCliked = false;
                        }

                    } catch (e) {
                        console.log(e)
                        toastr.error("Some thing went wrong !.Please try after some time.gg")
                        $scope.ifCliked = false;
                    }

                })
            // Meteor.call("clubCreation", angular.copy($scope.clubDetails), $stateParams.club_id, function (error, result) {
            //     if (error) {
            //         toastr.error("Some thing went wrong !.Please try after some time.")
            //         $scope.ifCliked = false;
            //     } else {


            //     }
            //     $scope.$apply();
            // });
        }
        /*********************Logo uploads****************************/
        /*
         * To upload club logo
         * 
         * @param : null
         * 
         * @return - null
         */

        let upload = function (pic) {
            $scope.clubActionBtns = false;
            let serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads"
            let userPath = localStorageService.get('user_id') + "/clubActivity/"
            let fileObj = pic;

            uploadService.uploadCheckService(fileObj, serverUrl, userPath, function (result) {
                // try {
                if (result.url) {
                    $scope.actionEdit = false
                    $scope.club.picFile = undefined
                    $scope.serverFileurl = result.url
                    $scope.createNewClub();
                }
                if (result.progress) {
                    $scope.progressRep = result.progress
                }
                if (!result) {
                    $scope.ifCliked = false;
                }
                // } catch (e) {
                //     console.log(e)
                // }
            })
        }
        $scope.myImage = '';
        $scope.myCroppedImage = '';
        $scope.handleFileSelect = function (evt) {
            var file = evt[0]
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $scope.myImage = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        /*
         * Validation for creating club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.imgSubmit = function (logo) {
            $scope.ifCliked = true;
            var reg = /^([A-Za-z0-9])[^]*$/;
            if ($scope.club == undefined || $scope.club == '' || $scope.club.name == undefined) {
                toastr.error("Please enter club title");
                $scope.loading = false;
                $scope.ifCliked = false;
                return false;
            }
            let myUserId = localStorageService.get('user_id')
            let school_id = localStorageService.get('school_id')
            authService.callAPI("/v0/club/check-name/" + school_id + "/" + myUserId + "/" + $scope.club.name, "GET",
                {}, function (resp) {
                    try {
                        if (!resp.error) {
                            let clubName = $scope.club.name.match(reg) ? "passed" : "failed";
                            if (clubName == 'failed') {
                                toastr.error("Please enter valid club title");
                                $scope.club.name = '';
                                $("#club_name").focus();
                                $scope.ifCliked = false;
                                return false;
                            } else {
                                $scope.clubName = $scope.club.name;
                            }

                            $scope.loading = true;
                            $scope.usersArray = [];
                            for (var i = 0; i < $scope.selectedUserstoClub.length; i++) {
                                var data = $scope.selectedUserstoClub[i];
                                for (var j = 0; j < data.length; j++) {
                                    $scope.usersArray.push(data[j]);
                                }
                            }
                            $scope.members = _.uniq($scope.usersArray);
                            if ($scope.club == undefined || $scope.club == '' || $scope.club.name == undefined) {
                                toastr.error("Please enter club title");
                                $scope.loading = false;
                                $scope.ifCliked = false;
                                return false;
                            }
                            if ($scope.club.name.length > 30) {
                                toastr.error("Title is too long !");
                                $scope.loading = false;
                                $scope.ifCliked = false;
                                return false;
                            }
                            if ($scope.club.name.length < 2) {
                                toastr.error("Title is too short !");
                                $scope.loading = false;
                                $scope.ifCliked = false;
                                return false;
                            }
                            if (!$scope.club.picFile) {
                                toastr.error("Please Upload Club Logo !");
                                $scope.loading = false;
                                $scope.ifCliked = false;
                                return false;
                            }
                            if ($scope.club.picFile) {
                                console.log($scope.club.picFile)
                                upload($scope.club.picFile);
                            } else {
                                $scope.createNewClub()
                            }
                        } else {
                            toastr.error("Club title exists, Please create club with another name");
                            $scope.loading = false;
                            $scope.ifCliked = false;
                            return false;
                        }
                        $scope.$apply();
                    } catch (e) {
                        console.log(e)
                    }

                })

        };
        $scope.addedMemberData = [];

        /*
         * To add members from common filter and get their role details
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.ProcessValue = function () {
            let selectedUser = _.filter(this.filteredNotEndorsedUsers, function (user) {
                return user.isChecked === true
            })
            if (selectedUser === undefined || selectedUser.length === 0) {
                toastr.error('Please Select the User')
                return false;
            } else {
                let members = [];
                if ($stateParams.club_id) {
                    Meteor.call("usersOfClub", $stateParams.club_id, function (error, result) {
                        if (error) {
                            toastr.error("Some thing went wrong !.Please try after some time.")
                        } else {
                            members = result;
                        }
                    })
                }
                _.each(selectedUser, function (eachUser, $index) {
                    if ($stateParams.club_id && members != null && eachUser) {
                        _.each(members, function (eachMember) {
                            if (eachUser._id === eachMember.user_id) {
                                toastr.error("Already existing member of club");
                                selectedUser[$index] = null;
                            }
                        })
                    }
                    _.each($scope.selectedUsers, function (eachAddedMember) {
                        if (eachUser && eachAddedMember) {
                            if (eachUser._id === eachAddedMember._id) {
                                eachAddedMember.isChecked = false;
                                toastr.error("Already added member");
                                selectedUser[$index] = null;
                            }
                        }

                    })
                    if (eachUser._id === uid) {
                        if (selectedUser[$index]) {
                            selectedUser[$index] = null;
                        }
                    }
                })
            }
            _.each(selectedUser, function (user) {
                if (user != null) {
                    $scope.selectedUsers.push(user);
                }
            })
            if (moduleDetails && moduleDetails.feature_role) {
                _.each(moduleDetails.feature_role, function (eachRole) {
                    let memberData = {};
                    memberData.mem_count = 0;
                    memberData.role = '';
                    if (eachRole.f_id == "hosComponent")
                        memberData.role = "HOS"
                    else if (eachRole.f_id == "hodComponent")
                        memberData.role = "HOD"
                    else if (eachRole.f_id == "parentComponent")
                        memberData.role = "Parent"
                    else if (eachRole.f_id == "teacherComponent")
                        memberData.role = "Teacher"
                    else if (eachRole.f_id == "studentComponent")
                        memberData.role = "Student"
                    else if (eachRole.f_id == "principalComponent")
                        memberData.role = "Principal"
                    _.each(selectedUser, function (member) {
                        if (member) {
                            if (member.role_ids) {
                                for (let i = 0; i < member.role_ids.length; i++) {
                                    if (member.role_ids[i] == eachRole.role_id && eachRole.name != "Parent Component") {
                                        memberData.mem_count++;
                                        break;
                                    }
                                }
                            }
                        }

                    })
                    if (memberData.mem_count > 0) {
                        $scope.addedMemberData.push(memberData)
                        //toastr.success(memberData.mem_count + " " + memberData.role + " added successfully")
                        $scope.showCreateButton = true;
                    }
                })
            }
            if ($scope.addedMemberData != null)
                $scope.ifMembersExist = true;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }


        $scope.showSearchBottomSheet = true
        $scope.showDropBox = () => {
            $scope.showSearchBottomSheet = true
        }

        /*
         * To identify role details from roleids 
         * 
         * @param : null
         * 
         * @return - Role name of specified roleids
         */

        $scope.identifyUserRoleId = function (role_id) {
            $scope.assignNames = '';
            let moduleDetails = [];
            moduleDetails = $scope.moduleDetailsData
            
            if (moduleDetails && moduleDetails.feature_role) {
                _.each(moduleDetails.feature_role, function (eachRole) {
                    if (eachRole.role_id == role_id) {
                        if (eachRole.f_id == "hosComponent")
                            $scope.assignNames += "HOS"
                        else if (eachRole.f_id == "hodComponent")
                            $scope.assignNames += "HOD"
                        else if (eachRole.f_id == "parentComponent")
                            $scope.assignNames += "Parent"
                        else if (eachRole.f_id == "teacherComponent")
                            $scope.assignNames += "Teacher"
                        else if (eachRole.f_id == "studentComponent")
                            $scope.assignNames += "Student"
                        else if (eachRole.f_id == "principalComponent")
                            $scope.assignNames += "Principal"
                        else if (eachRole.f_id == "adminComponent")
                            $scope.assignNames += "Super Admin"
                    }
                })
            }
            console.log($scope.assignNames)
            return $scope.assignNames;
        }

        //Start : To set mode of operation in create club page





        /*
         * Remove selected users from a club
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.removeMembers = () => {
            $scope.showSearchBox = false;
            var confirm = $mdDialog.confirm()
                .title('')
                .textContent('Are you sure you want to remove selected user ?')
                .targetEvent(event)
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function () {
                $scope.ifRemoved = true;
                let finalUsers;

                let userMember = _.filter($scope.userNames, function (user) {
                    return user.isChecked === true
                })
                let clubID = $stateParams.club_id
                let selectedClub = Club.findOne({
                    _id: clubID
                })
                let resUser = _.where(userMember, {
                    owner: false
                }); // to avoid club owner          

                let resUser2 = _.where(userMember, {
                    can_delete: true
                }); // to avoid (HOS,HOD and Principal) default users 

                Meteor.call("updateUsersToClub", resUser2, $stateParams.club_id, function (error, result) {
                    if (error) {
                        if (error.error) {
                            toastr.error("Some thing went wrong !.Please try after some time.")
                        } 
                    } else {
                        toastr.success("Users removed successfully!")
                    }
                    localStorageService.set('selectedClubId', $stateParams.club_id)
                    localStorageService.set('isClubOwnerID', Meteor.userId())
                    $state.go('clubPost')
                });
            });
        }

        $scope.removeMode = false;

        /*
         * To select all members from filter
         * 
         * @param : null
         * 
         * @return - null
         */

        $scope.selectAll = (selected) => { //select all clicks
            if (selected === true) {
                for (var i = 0; i < $scope.userNames.length; i++) {
                    if ($scope.userNames[i].is_exists == undefined) {
                        $scope.userNames[i].isChecked = true;
                    }
                }
                $scope.removeMode = true;
            }
            if (selected === false) {
                for (var i = 0; i < $scope.userNames.length; i++) {
                    $scope.userNames[i].isChecked = false;
                }
                $scope.removeMode = false;
            }
        }
        $scope.personArray = [];

        /*
         * To get selected members from filter
         * 
         * @param : null
         * 
         * @return - null
         */
        $scope.getClicked = (person) => { //On single checkbox clicks
            if (person) {

                let userMember = _.filter($scope.userNames, function (user) {
                    return user.isChecked === true
                })
                $scope.removeMode = ($stateParams.mode == 'remove' && userMember.length >= 1) ? true : false;
                if (person.isChecked === true) {
                    $scope.subjectEndorsementBtn = true;
                    if ($scope.personArray.indexOf(person.user_id) === -1) {
                        $scope.personArray.push(person);
                    }

                } else {
                    if ($scope.personArray.indexOf(person.user_id) === -1) {
                        $scope.personArray.splice($scope.personArray.indexOf(person), 1);
                    }
                }
                if ($scope.personArray.length === 0) {
                    $scope.subjectEndorsementBtn = false;
                }
                let userTo = _.filter($scope.userNames, function (user) {
                    return user.isChecked === true;
                })
                if ($scope.userNames.length === userTo.length) {
                    $scope.allItemsSelected = true;
                }
            }
        }
        $scope.addedUserDetails = [];
        $scope.members = [];
        $scope.membersObj = [];
        $scope.selectedUserstoClub = [];


        $scope.deleteFromSelectedMembers = () => {
            
            let selectedUserForRemove = _.filter($scope.selectedUsers, function (user) {
                
                return user.isChecked === false || !user.isChecked;
            })
            console.log($scope.selectedUsers)
            console.log(selectedUserForRemove)
            if (selectedUserForRemove != undefined && selectedUserForRemove.length <= 0) {
                toastr.error("Please select the user")
                return false;
            }
            $scope.selectedUsers = selectedUserForRemove
            // $scope.selectedUsers = _.filter($scope.selectedUsers, function (user) {
            //     return user.isChecked === false;
            // })
            // console.log($scope.selectedUsers)

        }

        $scope.makeChecked = (personList) =>{
            console.log(personList)
            // if(!personList.isChecked == true){
            //     personList.isChecked = false
            // }else{
            //     personList.isChecked = true
            // }
        }

    }
}
export default CreateClub;



// WEBPACK FOOTER //
// ./src/app/club_activity/controllers/createclubController.js